
        module.exports = __webpack_public_path__ + "assets/images/share-image.929453b8.jpg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 1200,
            height: 630,
            type: "jpg",
            bytes: 116227,

            toString: function() {
                return src;
            }
        };
    